module.exports = __webpack_public_path__ + "71cd7af713c21e526ce846e874f91818.png";